import React, { useState } from 'react';
import { FaWhatsapp, FaTimes } from 'react-icons/fa';
import '../styles/whatsapp.css';

const Whatsapp = () => {
  const [hovered, setHovered] = useState(false);

  return (
    <div className="wa-wrap">
      {/* Tooltip label */}
      <span className={`wa-label${hovered ? ' wa-label--show' : ''}`}>
        Chat on WhatsApp
      </span>

      <a
        href="https://wa.link/cb9r75"
        target="_blank"
        rel="noreferrer"
        className="wa-btn"
        aria-label="Chat with KMK Industries on WhatsApp"
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
      >
        <FaWhatsapp className="wa-icon" />
        {/* Pulse ring */}
        <span className="wa-pulse" aria-hidden="true" />
      </a>
    </div>
  );
};

export default Whatsapp;
